export class CharacterClasses {
  public static characterClassNames = [
    'Scioppo/a',
    'Nebelkrähe',
    'Talhüter*in',
    'Kaskarier*in',
    'Harpye',
    'Argunathim',
  ];

  static get allClasses() {
    return CharacterClasses.characterClassNames.sort().map((value) => {
      const transVal = value
        .toLowerCase()
        .replace('/', '_')
        .replace('*', '_')
        .replace('ü', 'u')
        .replace('ö', 'o')
        .replace('ä', 'a');
      return { text: value, value: transVal };
    });
  }
}
